export default class CategoryCustomer {
    constructor() {
        this.id = "";
        this.name = "";
    }
    update(data) {
        this.id = data.id;
        this.name = data.name;
    }
}